module.exports = "https://cdn-static.chanmama.com/sub-module/static-file/9/5/1bdcb98f77"